/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import * as React from 'react';

/* SERVICES */

import { useAppContextoReact } from '../../servicos/app/AppContextoReact';

/* COMPONENTES */

import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import {Box, Grid, CircularProgress} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Bananinha, { IBananinhaDelegate } from '../../componentes/widgets/Bananinha';

/* INTERFACES */

interface IFormLogin
{
    setNewPassword: (newPassword:boolean) => void
}

const FormLogin = (props:IFormLogin) =>
{
    const userContext = useAppContextoReact();
    
    const [email, setEmail] = React.useState<string>('');
    const [password, setPassword] = React.useState<string>('');
    const [error, setError] = React.useState<boolean>(false);
    const [bananinhaDelegate, setBananinhaDelegate] = React.useState<IBananinhaDelegate|undefined>(undefined);
    const [loading, setLoading] = React.useState<boolean>(false);

    const handleError = React.useCallback((errorMsg?:string) => 
	{
		bananinhaDelegate?.abrir(errorMsg ? errorMsg : 'Erro de autenticação, usuário ou senha incorretos.', "error");
	}, [bananinhaDelegate])
    
    const handleEmailChange = (e: { target: { value: React.SetStateAction<string>; }; }) => 
    {
        setEmail(e.target.value);
    };

    const handlePasswordChange = (e: { target: { value: React.SetStateAction<string>; }; }) => {
        setPassword(e.target.value);
    };

    const handleLogin = async () =>
    {
        setLoading(true);
        try
        {
            const res:any = await userContext?.usuario.Login(email,password);

            if (res.code === "auth/user-not-found"){
                handleError("E-mail não encontrado.")
            }else if (res.code === "auth/wrong-password"){
                handleError("Senha incorreta.")
            }else if (res.code === "auth/invalid-login-credentials"){
                handleError("E-mail ou senha inválidos.")
            }else if (res.code === "auth/too-many-requests"){
                // handleError("Acesso a essa conta foi temporáriamente suspenso por excesso de tentativas inválidas. Você pode restaurá-lo imediatamente através da redefinição de senha, ou pode tentar novamente mais tarde.")
                handleError("Conta suspensa. Você pode restaurá-la através da redefinição de senha, ou tentar novamente mais tarde.")
            }else{
                const resExp:any = await userContext.usuario.ExpLogin().finally(() => window.location.reload());
                console.log(resExp, res)
            }
        }
        catch(e)
        {
            if (e.code === "auth/user-not-found")
                handleError("E-mail não encontrado.")
            else
                handleError();
        }
        finally
        {
            setLoading(false);
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
          handleLogin();
        }
      };

    return <>
        <Bananinha getDelegate={delegate => bananinhaDelegate ?? setBananinhaDelegate(delegate)}/>
        <Avatar sx={{ m: 1, width: 80, height: 80 }}>
            <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h2">Acervo Digital</Typography>
        <Box component="form" id={'formLoginAcervo'} noValidate sx={{ mt: 1 }}>
            <TextField 
                margin="normal" 
                required 
                fullWidth 
                id="email" 
                label="E-mail" 
                name="email" 
                value={email} 
                onChange={handleEmailChange} 
                onKeyDown={handleKeyDown}
                autoFocus 
                error={error} 
            />
            <TextField 
                margin="normal"
                required	
                fullWidth 
                name="password" 
                label="Senha" 
                type="password" 
                id="password" 
                value={password} 
                onChange={handlePasswordChange} 
                onKeyDown={handleKeyDown}
                error={error} 
            />
            {
                error &&
                    <Box display={'flex'} flexDirection={'row'} sx={{width: '100%', py:3, px:5, mt:3, borderRadius: 3}}>
                        <Typography component="p" variant="pxs" sx={{color: "#fff"}}>Erro de autenticação, usuário ou senha incorretos.</Typography>
                    </Box>
            }							
            <Button fullWidth variant="contained" sx={{ mt: 3, mb: 2, height: 50 }} onClick={() => {handleLogin()}} disabled={loading}>
                {loading ? <CircularProgress size={24} color="inherit" /> : 'Entrar'}
            </Button>
            <Grid container>
                <Grid item xs display={'flex'} justifyContent={'center'}>
                    <Link href="#" variant="body2" onClick={() => {props.setNewPassword(true)}}>
                        Esqueceu sua senha?
                    </Link>
                </Grid>
            </Grid>
        </Box>
    </>
}

export default FormLogin; 